import React, { useEffect, useContext } from 'react'
import ScrollToTop from '../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import RoleImg from './../../../../assets/images/weerp/web-image/super-admin/role.png';
import EmployeesImg from './../../../../assets/images/weerp/web-image/super-admin/emplyee.png';
import { ProjectTypeContext } from '../../../../ContextHandle';
export default function RoleEmployee({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
    /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const panelName   = projectType.panelName;
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(2002);
        document.title = 'Role & Employees | ' + projectName + ' web';
        setDefaultWebActiveMenu(4);
    }, [projectName]);

    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}/introduction`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">{panelName}</li>
                        <li className="breadcrumb-item active" aria-current="page">Role & Employees</li>
                    </ol>
                </nav>
                <div id="dashboards" ref={sectionRefs['4']}>
                    <h4 className="font-weight-bold mt-5  ">Role & Employees</h4>
                    <h5 className="border-top font-weight-bold mt-2 pt-2 text-primary"># Roles</h5>
                    <p className="pt-3">Admin can manage multiple roles and assign permissions.</p>

                    <div className='pt-3'>
                        <img src={RoleImg} className="w-100 rounded" alt="Dashboard"></img>
                    </div>
                   
                </div>
                <div id="dashboards" ref={sectionRefs['4']}> 
                <h5 className="border-top font-weight-bold mt-5 pt-2 text-primary"># Employees</h5>
                <p className="pt-3">Admin can manage role wise employees. and can assign permissions. and Employee can active or inactive. </p>
                
                    <div className='pt-3'>
                        <img src={EmployeesImg} className="w-100 rounded" alt="Employee"></img>
                    </div>
                  
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/admin/dashboard`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Dashboard</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/admin/business`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Business</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
